<div class="support-banner" role="alert" aria-live="polite">
  <div class="support-banner__content">
    <split-icon class="support-banner__icon" name="alert-circle" size="16"></split-icon>
    <p class="support-banner__message">
      Ocorreu um erro interno. Não foi possível emitir esta nota.
    </p>
  </div>

  <a class="support-banner__cta"
     [href]="whatsAppUrl"
     target="_blank"
     rel="noopener noreferrer"
     aria-label="Falar com suporte via WhatsApp">
    <split-icon name="brand-whatsapp" size="16"></split-icon>
    <span>Falar com suporte</span>
  </a>
</div>
